import React, { useState } from "react";
import { ReactComponent as PlayIcon } from "svgs/play.svg";
import { ReactComponent as PlayIconRound } from "svgs/rounded-play.svg";
import clsx from "clsx";
import Image from "components/image";

const VideoPlayer = ({ video, videoId, prioritizeYouTube }) => {
	if (prioritizeYouTube && videoId) {
		return (
			<iframe width="100%" height="100%"
				src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=1&mute=1`}
				title="YouTube video"
				allow="autoplay; encrypted-media; gyroscope; picture-in-picture fullscreen"
				className="size-full"
			/>
		);
	}

	if (video?.url) {
		return (
			<video className="size-full object-cover" preload="none" loading="lazy" controls autoPlay muted loop playsInline>
				<source src={`${video.url}#t=0.001`} type="video/mp4" />
				Your browser does not support HTML5 video.
			</video>
		);
	}

	return null;
};

const VideoThumbnail = ({ data, setIsPlaying }) => {
	const { videoTitle, videoButton, shopifyVideo, hideThumbnailShadow = false, 
		videoId, prioritizeYouTube = true, videoThumbnail } = data || {};
	const thumbnailUrl = videoThumbnail 
	?? (prioritizeYouTube && videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : shopifyVideo?.preview?.url);
	return (
		<div className="relative size-full flex-center bg-primary" onClick={() => setIsPlaying(true)}>
			{videoThumbnail ? ( <Image image={videoThumbnail} 
				className={clsx(!hideThumbnailShadow && "opacity-80", "inset-0 size-full object-cover")} />
			) : thumbnailUrl && ( <img src={thumbnailUrl} alt="Video thumbnail" 
				className={clsx(!hideThumbnailShadow && "opacity-80", "inset-0 size-full object-cover")} />
			)}
			<div className={clsx(hideThumbnailShadow ? "bg-opacity-0" : "bg-opacity-50",
				"absolute inset-0 flex flex-col justify-center items-center bg-darkGray text-white text-left p-4")} >
				{videoTitle && <h4 className="text-center sm:text-h2">{videoTitle}</h4>}
				{videoButton ? (
					<button className="btn-quinary text-xs mt-5 sm:text-base whitespace-nowrap 
					tracking-normal w-[80%] h-[20%] sm:w-auto max-w-[90%] sm:max-w-none">
						{videoButton}
						<div className="pl-2">
							<PlayIcon className="size-2 sm:size-3" />
						</div>
					</button>
				)
					: <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 
				-translate-y-1/2 bg-grey/80 rounded-full p-4 flex items-center justify-center z-10">
						<PlayIconRound className="size-10 pl-2 text-white" />
					</button>
				}
			</div>
		</div>
	);
};

const Video = ({ data }) => {
	const { url, shopifyVideo, prioritizeYouTube = true } = data || {};
	const videoId = url?.split(/watch\?v=|embed\//)[1] || null;
	const [isPlaying, setIsPlaying] = useState(false);

	if (isPlaying) return <VideoPlayer video={shopifyVideo} videoId={videoId} prioritizeYouTube={prioritizeYouTube} />;

	return <VideoThumbnail data={{ ...data, videoId }} setIsPlaying={setIsPlaying} />;
};
export default Video;
